"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader, CircleCheck } from "lucide-react";
export default function VolunteerSignUp() {
  return;
}
function VolunteerForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-8 text-center animate-in fade-in zoom-in duration-500">
        <div className="mb-4 rounded-lg bg-primary/20 p-3">
          <CircleCheck className="size-8 text-primary" />
        </div>
        <h3 className="font-default text-2xl font-semibold text-foreground uppercase tracking-wider">
          Uplink Established
        </h3>
        <p className="mt-2 font-default text-muted-foreground">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-8 rounded-md border-primary text-primary hover:bg-primary/10">
          New Transmission
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid gap-5 sm:grid-cols-2">
        <FormField control={control} name="full_name" render={({
        field
      }) => <FormItem className="sm:col-span-2">
              <FormLabel className="font-default text-xs uppercase tracking-widest text-muted-foreground">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="OPERATOR NAME" className="rounded-md border-input bg-background/50 font-default focus-visible:ring-primary/50" {...field} />
              </FormControl>
              <FormMessage className="font-default text-[10px]" />
            </FormItem>} />

        <FormField control={control} name="email" render={({
        field
      }) => <FormItem className="sm:col-span-2">
              <FormLabel className="font-default text-xs uppercase tracking-widest text-muted-foreground">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="COMM_ID@GEOCOSMOS.AM" className="rounded-md border-input bg-background/50 font-default focus-visible:ring-primary/50" {...field} />
              </FormControl>
              <FormMessage className="font-default text-[10px]" />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-xs uppercase tracking-widest text-muted-foreground">Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+374 00 000000" className="rounded-md border-input bg-background/50 font-default focus-visible:ring-primary/50" {...field} />
              </FormControl>
              <FormDescription className="text-[10px] font-default opacity-70">
                Secure voice channel
              </FormDescription>
              <FormMessage className="font-default text-[10px]" />
            </FormItem>} />

        <FormField control={control} name="city" render={({
        field
      }) => <FormItem>
              <FormLabel className="font-default text-xs uppercase tracking-widest text-muted-foreground">Location</FormLabel>
              <FormControl>
                <Input placeholder="COORDINATES / CITY" className="rounded-md border-input bg-background/50 font-default focus-visible:ring-primary/50" {...field} />
              </FormControl>
              <FormMessage className="font-default text-[10px]" />
            </FormItem>} />
      </div>

      <FormField control={control} name="availability" render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest text-muted-foreground">Service Interest</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className="rounded-md border-input bg-background/50 font-default focus:ring-primary/50">
                  <SelectValue placeholder="Select mission type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="bg-card border-border font-default">
                {["Satellite Imagery", "Geodetic Survey", "Digital Mapping", "DSM/DTM Modeling"].map((option, i) => <SelectItem key={i} value={option} data-index={i} className="focus:bg-primary focus:text-primary-foreground">
                      {option}
                    </SelectItem>)}
              </SelectContent>
            </Select>
            <FormDescription className="text-[10px] font-default opacity-70">
              Specify the geospatial intelligence required
            </FormDescription>
            <FormMessage className="font-default text-[10px]" />
          </FormItem>} />

      <FormField control={control} name="comments" render={({
      field
    }) => <FormItem>
            <FormLabel className="font-default text-xs uppercase tracking-widest text-muted-foreground">Mission Parameters</FormLabel>
            <FormControl>
              <textarea {...field} placeholder="Enter technical specifications or project requirements..." className="flex min-h-[100px] w-full rounded-md border border-input bg-background/50 px-3 py-2 text-base font-default shadow-xs placeholder:text-muted-foreground/50 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" />
            </FormControl>
            <FormMessage className="font-default text-[10px]" />
          </FormItem>} />

      {submitError && <div className="rounded-md border border-destructive/50 bg-destructive/10 p-3 text-xs font-default text-destructive">
          {submitError}
        </div>}

      <Button type="submit" disabled={isSubmitting} className="mt-6 h-12 w-full rounded-md bg-primary text-primary-foreground font-default text-sm font-bold uppercase tracking-widest shadow-lg transition-all hover:brightness-110 active:scale-[0.98]">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            Syncing...
          </> : "Initialize Uplink"}
      </Button>
    </Form>;
}